export const defaultState = {
  consults: [],
  unrepliedChannel: null,
  fetchingConsults: false,
  isFilterLoading: false,
  activeConsult: {
    channel: null,
    consultationId: null,
    user: {
      userName: '',
      userId: null,
      gender: '',
      age: null,
      relativeName: null,
      dob: null,
    },
    doctorType: '',
    sponsor: { sponsorName: '', id: 0 },
    issues: '',
    doctorTimetoken: null,
    userTimetoken: null,
    labels: [],
    files: [],
    userId: null,
    tUserId: null,
    digitisationRequestId: null,
  },
  currentUserInfo: null,
  consultPatientInfo: null,
  uiConfig: null,
  invalidReasons:[],
  quickReplySuggestions:[],
  activeConsultChannels: {
    consultationId: null,
    channels: [],
  }
};

export default function consults(state = defaultState, action) {
  switch (action.type) {
    case 'SET_CONSULTS':
      return Object.assign({}, state, {
        consults: action.payload.consults || [],
        fetchingConsults: false,
        isFilterLoading: false,
      });
    case 'SET_FETCHING_CONSULTS':
      return Object.assign({}, state, {
        fetchingConsults: true,
      });
    case 'SET_FILTER_LOADING':
      return Object.assign({}, state, {
        isFilterLoading: true,
      });
    case 'CLEAR_FILTER_LOADING':
      return Object.assign({}, state, {
        isFilterLoading: false,
      });
    case 'SET_ACTIVE_CONSULT': {
      const nextConsult = action.payload.consult || {};
      const prevConsult = state.activeConsult || {};
      // `files` never comes from the requests/consultations list API - it is fetched separately
      // (getPrescriptionFiles) and merged in via ADD_FILES_TO_ACTIVE_CONSULT, and that fetch only
      // runs when the active case *changes*. Re-selecting the same case (searching for the case
      // that is already open auto-selects it again as the first result) hands us a fresh list
      // object with no `files`, which blanks the "Uploaded Files" panel with nothing left to
      // re-trigger the fetch. Carry the already-fetched files over only when the case identity is
      // unchanged, so a different case always starts clean and files can never leak across cases.
      const isSameCase = prevConsult.digitisationRequestId || nextConsult.digitisationRequestId
        ? !!nextConsult.digitisationRequestId &&
          nextConsult.digitisationRequestId === prevConsult.digitisationRequestId
        : !!nextConsult.consultationId &&
          nextConsult.consultationId === prevConsult.consultationId;
      const shouldKeepFiles =
        isSameCase && !nextConsult.files?.length && prevConsult.files?.length > 0;
      // Deliberately a copy, not the same array: `activeConsult.files` is an effect dependency
      // (CommonSecondStep re-fetches the labs/medicines carts off its identity), and today a
      // re-select changes that identity. Handing back a new array keeps every one of those
      // effects firing exactly as often as before - only the data they read is no longer lost.
      return Object.assign({}, state, {
        activeConsult: shouldKeepFiles
          ? { ...nextConsult, files: [...prevConsult.files] }
          : nextConsult,
      });
    }
    case 'SET_ACTIVE_CONSULT_CHANNELS':
      return Object.assign({}, state, {
        activeConsultChannels: action.payload,
      });
    case 'ADD_FILES_TO_ACTIVE_CONSULT': {
      return Object.assign({}, state, {
        activeConsult: {
          ...state.activeConsult,
          // Normalised so a response without a `documents` array renders the
          // "no uploaded prescription" empty state instead of hiding the section.
          files: action.payload.files || [],
        },
      });
    }
    case 'ADD_CONSULTS': {
      return Object.assign({}, state, {
        consults: [...state.consults, ...action.payload.consults],
        fetchingConsults: false,
      });
    }
    case 'SET_UNREPLIED_CHANNEL': {
      console.log('setting unreplied channel', action);
      return Object.assign({}, state, {
        unrepliedChannel: action.payload,
      });
    }
    case 'LOGOUT_USER': {
      return Object.assign({}, state, defaultState);
    }
    case 'SET_CONSULT_USER_INFO': {
      return Object.assign({}, state, {
        currentUserInfo: action.payload,
      });
    }
    case 'SET_CONSULTATION_PATIENT_INFO': {
      return Object.assign({}, state, {
        consultPatientInfo: action.payload,
      });
    }
    case 'SET_UI_CONFIG': {
      return Object.assign({}, state, {
        uiConfig: action.payload,
      });
    }
    case 'SET_DIGITISATION_INVALID_REASONS': {
      return Object.assign({}, state, {
        invalidReasons: action.payload,
      });
    }
    case 'SET_QUICK_REPLY_SUGGESTIONS': {
      return Object.assign({}, state, {
        quickReplySuggestions: action.payload,
      });
    }
    default:
      return state;
  }
}
